/**
 * Normalizes filter keys and values for URL ↔ Algolia facet state.
 * Values in URLs are lowercased when serializing; use `normalizeFilterValue` when parsing.
 */

export { normalizeFilterValue } from './resolve-facet-value-from-url';

/**
 * Normalizes a filter attribute key to lowercase.
 * This ensures case-insensitive parameter key matching.
 * @param key The parameter key (e.g., 'Remoteness', 'LOCATION')
 * @returns The normalized lowercase key (e.g., 'remoteness', 'location')
 */
export function normalizeFilterKey(key: string): string {
  return key.toLowerCase();
}
